import { Root } from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'

const labelVariants = cva(
  'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  {
    variants: {
      unstyled: {
        true: '',
        false: 'font-medium text-xs leading-none',
      },
    },
    defaultVariants: {
      unstyled: false,
    },
  }
)

export type LabelProps = ComponentPropsWithoutRef<typeof Root> &
  VariantProps<typeof labelVariants>

export const Label = forwardRef<ElementRef<typeof Root>, LabelProps>(
  ({ className, unstyled, ...props }, ref) => (
    <Root
      ref={ref}
      className={cn(labelVariants({ unstyled, className }))}
      {...props}
    />
  )
)
Label.displayName = Root.displayName
